import { BETA_MODE } from "../../lib/beta";

// Sticky black Beta banner shown across the top of every /app/* page during
// Beta. Different from the marketing <BetaBanner /> which is a dashed yellow-
// ochre callout. Returns null when BETA_MODE is false so the gate is a single
// import-level flag.

export default function BetaBanner() {
  if (!BETA_MODE) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        background: "var(--ink)",
        color: "var(--paper-50)",
        padding: "6px 22px",
        fontFamily: "var(--f-ui)",
        fontSize: 11,
        letterSpacing: "0.08em",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
      }}
    >
      <span
        style={{
          padding: "2px 6px",
          background: "var(--ochre)",
          color: "var(--ink)",
          borderRadius: 2,
          fontWeight: 700,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
          fontSize: 9,
        }}
      >
        Beta
      </span>
      <span
        style={{
          fontStyle: "italic",
          color: "rgba(244,236,216,0.85)",
        }}
      >
        Sie testen Vitanara. Premium folgt ab 1. September 2026.
      </span>
    </div>
  );
}
